import $ from "jquery";

$(document).ready(function() {
	initAutocompleter($('[data-ctl="autocompleter"]'));
    initTags($('[data-ctl="tags"]'));
});

function initAutocompleter(elements) {
	$.each(elements, function(index, el) {
		var field = $(el);
        if (!field.is('.init')) {
            field.addClass('init');
            var container = $('<div class="input-group autocompleter-container"></div>');
            var groupAppend = field.next('.input-group-append');
            field.wrap(container);
            container = field.parent('div');
            var manualsearch = field.attr('data-manualsearch') == 'true';
            var forcesearch = false;
            var minLength = field.attr('data-minlength') || 2;
            var displayEl = field.clone();
            displayEl.attr('id', displayEl.attr('id') + 'display' + Math.ceil(Math.random() * 200))
                .attr('name', field.attr('data-display-name') || '')
                .attr('data-val', field.attr('fullvalue'))
                .val(field.attr('fullvalue'));
            field.addClass('d-none').after(displayEl);

            if (field.attr('data-clear')) {
                // var container = $('<div class="input-group"></div>');
                // displayEl.wrap(container);
                displayEl.after($('<div class="input-group-append"><button data-clear class="btn btn-form" type="button"><i class="fa bi-x"></i></button></div>'));
            }

            container.parent().find('[data-clear]').click(function() {
                displayEl.val('');
                field.val('');
                field.trigger('change');
            });
            if (manualsearch) {
                displayEl.on('keyup', function (ev) {
                    if (ev.keyCode === $.ui.keyCode.ENTER) {
                        forcesearch = true;
                        displayEl.autocomplete('search');
                    }
                });
            }
            if (field.attr('data-autosearch') === 'true') {
                minLength = 0;
                displayEl.on('focus', function (ev) {
                    forcesearch = true;
                    displayEl.autocomplete('search');
                });
            }
            if (field.attr('data-autoexpand') === 'true') {
                displayEl.on('blur', function (ev) {
                    field.val(displayEl.val());
                });
            }
            // if (!field.is('[data-no-icon]')) {
            //     $('<div class="input-group-prepend loader-indicator"><span class="input-group-text"><i class="fa bi-search"></i><i class="fa fa-spinner fa-spin"></i></span></div>').insertAfter(field);
            // }
            displayEl.autocomplete({
                appendTo: field.attr('data-results') ? displayEl.closest('.dropdown-menu').find(field.attr('data-results')) : null,
                minLength: minLength,
                position: { collision: 'flip' },
                classes: {
                    "ui-autocomplete": field.attr('data-ul-class')
                },
                search: function () {
                    if (manualsearch) {
                        if (!forcesearch) return false;
                        forcesearch = false;
                    }
                },
                updater: function (obj) {
                    var item = JSON.parse(obj);
                    field.attr('value', item.value);
                    displayEl.val(item.label);
                    field.trigger('change');
                    return item.label;
                },
                source: function (request, response) {
                    var postData = { search: request.term };
                    if (field.is('[data-autocompleter-param]')) {
                        $.each(field.attr('data-autocompleter-param').split(","), function(i, el) {
                            var ctl = $(el.trim());
                            if (ctl.length === 1) {
                                postData[ctl.attr('name')] = ctl.val();
                            }
                        });
                    }
                    $.ajax({
                        url: field.data('url'),
                        dataType: "json",
                        timeout: connection.defaultTimeout,
                        data: postData,
                        beforeSend: function () {
                            container.addClass('autocompleter-loading');
                        },
                        success: function (data) {
                            var cancel = (field.triggerHandler('loaded', { data: data }));
                            if (cancel !== false) {
                                response($.map(data, function (item) {
                                    return {
                                        label: item.label,
                                        value: item.value,
                                        hint: item.hint
                                    }
                                }));
                            }
                        },
                        complete: function () {
                            container.removeClass('autocompleter-loading');
                        }
                    });
                },
                // focus: function(event, ui) {
                //     $(data.menu.active).find('div.ui-state-active').removeClass('ui-state-active');
                //     $(prevLi).find('div').addClass('ui-state-active');
                // },
                select: function (event, ui) {
                    debugger;
                    if (ui.item.value == null || ui.item.value === '-') {
                        displayEl.val('');
                        return false;
                    }

                    field.val(ui.item.value);
                    displayEl.val(ui.item.label);
                    field.trigger('changed', {
                        value: ui.item.value,
                        label: ui.item.label,
                        field: displayEl
                    });
                    return false;
                }
            })
            .data('ui-autocomplete')._renderItem = function (ul, item) {
                if (!field.attr('data-results')) {
                    $(ul).removeClass('ui-autocomplete').addClass('dd-options ctl-autocompleter-options');
                }
                var hint = (item.hint != undefined) ? ' <span class="hint">' + item.hint + '</span>' : '';
                return $('<li'+(item.disabled ? ' disabled="disabled"' : '')+'>')
                    .append('<a class="dd-option"'+(item.disabled ? ' disabled="disabled"' : '')+'>' +
                        (item.prefix || '') + item.label + hint +
                        '</a>')
                    .appendTo(ul);
            };
            displayEl.autocomplete().data('ui-autocomplete')._renderMenu = function (ul, items) {
                var that = this;
                if (field.attr('data-autoexpand') == 'true') {
                    if (that.term.length === 0) {
                        that._renderItemData(ul, {
                            hint: "",
                            disabled: true,
                            label: "Eintrag wählen oder neuen Erfassen",
                            value: null,
                        });
                    } else {
                        that._renderItemData(ul, {
                            prefix: "<b>Neuer Eintrag: </b>",
                            label: that.term,
                            value: that.term,
                        });
                    }
                }
                $.each(items, function (index, item) {
                    that._renderItemData(ul, item);
                });
                ul.addClass(field.data('menuclass')).css({'display': 'inline-block', 'max-height': 300});
                if (items.length === 1 && items[0].value === null) {
                    $(field).trigger('no-items-found', { listEl: ul });
                }
                $(field).trigger('menu-rendered', {
                    autocompleter: that,
                    ul: ul,
                    items: items,
                });
            };
            if (groupAppend.length > 0) {
                groupAppend.appendTo(field.parent());
            }
        }
	});
}
window.initAutocompleter = initAutocompleter;

function addTagTo(autocompleterEl, tag) {
    var newEl = $(`<span class="tag badge badge-primary" data-id="${tag.value}">
        ${tag.label}
        <span data-role="remove"></span>
    </span>`);
    newEl.find('[data-role="remove"]').click(() => {
        newEl.remove();
        var newValue = $.map(autocompleterEl.find('.badge'), el => { return $(el).attr('data-id')+'|'+$(el).text().trim(); });
        autocompleterEl.find('.form-control').val(newValue.join(","));
    });

    if (autocompleterEl.find('.badge[data-id="'+tag.value+'"]').length === 0) {
        autocompleterEl.find('.bootstrap-tagsinput input').before(newEl);
        var newValue = $.map(autocompleterEl.find('.badge'), el => {
            return $(el).attr('data-id') + '|' + $(el).text().trim();
        });
        autocompleterEl.find('.form-control').val(newValue.join(","));
        console.log(autocompleterEl.find('.form-control').val());
    }
}

function initTags(elements) {
    $.each(elements, function (index, el) {
        var field = $(el);
        if (!field.is('.init')) {
            field.addClass('init');
            var container = $('<div class="input-group autocompleter-container tags"></div>');
            var groupAppend = field.next('.input-group-append');
            field.wrap(container);
            container = field.parent('div');
            var manualsearch = field.attr('data-manualsearch') == 'true';
            var forcesearch = false;
            var minLength = field.attr('data-minlength') || 2;
            var displayContainerEl = $(`<div class="bootstrap-tagsinput">
                <input type="text" placeholder="${field.attr('placeholder')||''}">
            </div>`);
            field.addClass('d-none').after(displayContainerEl);
            var displayEl = displayContainerEl.find('input');
            displayContainerEl.click(() => {
                setTimeout(() => { displayEl.focus(); }, 50);
            });

            var tagsVal = [];
            if (field.closest('.form-group').find('[data-tags]').length === 1) {
                var tagsValContent = (field.closest('.form-group').find('[data-tags]').html().trim() || '');
                if (tagsValContent !== "") {
                    tagsVal = tagsValContent.split(",");
                }
            }
            $.each(tagsVal, function (i, item) {
                var values = item.split("|");
                if (tagsValContent !== "") {
                    addTagTo(container, {value: values[0], label: values[1]});
                }
            });

            if (field.attr('data-clear')) {
                displayEl.after($('<div class="input-group-append"><button data-clear class="btn btn-form" type="button"><i class="fa bi-x"></i></button></div>'));
            }

            container.parent().find('[data-clear]').click(function() {
                displayEl.val('');
                field.val('');
                field.trigger('change');
            });
            if (manualsearch) {
                displayEl.on('keyup', function (ev) {
                    if (ev.keyCode === $.ui.keyCode.ENTER) {
                        forcesearch = true;
                        displayEl.autocomplete('search');
                    }
                });
            }
            if (field.attr('data-autosearch') === 'true') {
                minLength = 0;
                displayEl.on('focus', function (ev) {
                    forcesearch = true;
                    displayEl.autocomplete('search');
                });
            }
            displayEl.autocomplete({
                appendTo: field.attr('data-results') ? displayEl.closest('.dropdown-menu').find(field.attr('data-results')) : null,
                minLength: minLength,
                position: { collision: 'flip' },
                classes: {
                    "ui-autocomplete": field.attr('data-ul-class')
                },
                search: function () {
                    if (manualsearch) {
                        if (!forcesearch) return false;
                        forcesearch = false;
                    }
                },
                updater: function (obj) {
                    var item = JSON.parse(obj);
                    field.trigger('change');
                    return item.label;
                },
                source: function (request, response) {
                    var postData = { search: request.term };
                    if (field.is('[data-autocompleter-param]')) {
                        $.each(field.attr('data-autocompleter-param').split(","), function(i, el) {
                            var ctl = $(el.trim());
                            if (ctl.length === 1) {
                                postData[ctl.attr('name')] = ctl.val();
                            }
                        });
                    }
                    $.ajax({
                        url: field.data('url'),
                        dataType: "json",
                        timeout: connection.defaultTimeout,
                        data: postData,
                        beforeSend: function () {
                            container.addClass('autocompleter-loading');
                        },
                        success: function (data) {
                            var cancel = (field.triggerHandler('loaded', { data: data }));
                            if (cancel !== false) {
                                response($.map(data, function (item) {
                                    return {
                                        label: item.label,
                                        value: item.value,
                                        hint: item.hint
                                    }
                                }));
                            }
                        },
                        complete: function () {
                            container.removeClass('autocompleter-loading');
                        }
                    });
                },
                select: function (event, ui) {
                    if (ui.item.value == null || ui.item.value === '-') {
                        displayEl.val('');
                        return false;
                    }

                    addTagTo(container, {value: ui.item.value, label: ui.item.label});
                    displayEl.val('');
                    field.trigger('changed', {
                        value: ui.item.value,
                        label: ui.item.label,
                        field: displayEl
                    });
                    return false;
                }
            })
                .data('ui-autocomplete')._renderItem = function (ul, item) {
                if (!field.attr('data-results')) {
                    $(ul).removeClass('ui-autocomplete').addClass('dd-options ctl-autocompleter-options');
                }
                var hint = (item.hint != undefined) ? ' <span class="hint">' + item.hint + '</span>' : '';
                return $('<li'+(item.disabled ? ' disabled="disabled"' : '')+'>')
                    .append('<a class="dd-option"'+(item.disabled ? ' disabled="disabled"' : '')+'>' +
                        (item.prefix || '') + item.label + hint +
                        '</a>')
                    .appendTo(ul);
            };
            displayEl.autocomplete().data('ui-autocomplete')._renderMenu = function (ul, items) {
                var that = this;
                if (field.attr('data-autoexpand') == 'true') {
                    if (that.term.length === 0) {
                        that._renderItemData(ul, {
                            hint: "",
                            disabled: true,
                            label: "Eintrag wählen oder neuen Erfassen",
                            value: null,
                        });
                    } else {
                        that._renderItemData(ul, {
                            prefix: "<b>Neuer Eintrag: </b>",
                            label: that.term,
                            value: 'new-'+that.term,
                        });
                    }
                }
                $.each(items, function (index, item) {
                    if (container.find('.badge[data-id="'+item.value+'"]').length === 0) {
                        that._renderItemData(ul, item);
                    }
                });
                ul.addClass(field.data('menuclass')).css({'display': 'inline-block', 'max-height': 300});
                if (items.length === 1 && items[0].value === null) {
                    $(field).trigger('no-items-found', { listEl: ul });
                }
                $(field).trigger('menu-rendered', {
                    autocompleter: that,
                    ul: ul,
                    items: items,
                });
            };
            if (groupAppend.length > 0) {
                groupAppend.appendTo(field.parent());
            }
        }
    });
}
window.initTags = initTags;
